module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/colorselect/asset/selected_font.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/colorselect/asset/selected_font.png
// module id = 1081
// module chunks = 418